import apiClient from "../../../utils/interceptor";
import {
  ApiResponse,
  MachineInstanceData,
  CreateMachineInstanceParams,
} from "./interface";
import { API_URLS } from "../../../constants";

const getAuthToken = (): string | null => {
  return localStorage.getItem("auth_token");
};

// Get all machine instances by machine ID and version ID
export const getInstancesByMachineId = async (
  machineId: string,
  machineVersionId: string
): Promise<ApiResponse<MachineInstanceData[]>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.get<ApiResponse<MachineInstanceData[]>>(
      `${API_URLS.MACHINE_INSTANCE.GET_INSTANCES}/${machineId}/${machineVersionId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching machine instances:", error);
    throw error;
  }
};

export const createMachineInstance = async (
  params: CreateMachineInstanceParams
): Promise<ApiResponse<null>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.post<ApiResponse<null>>(
      API_URLS.MACHINE_INSTANCE.CREATE_INSTANCE,
      params,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating machine instance:", error);
    throw error;
  }
};

export const deleteMachineInstance = async (
  instanceId: string
): Promise<ApiResponse<null>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.delete<ApiResponse<null>>(
      API_URLS.MACHINE_INSTANCE.DELETE_INSTANCE,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: { machine_instance_id: instanceId },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting machine instance:", error);
    throw error;
  }
};